import { render, staticRenderFns } from "./Dialog_DiscountType.vue?vue&type=template&id=708f6481&scoped=true&"
import script from "./Dialog_DiscountType.vue?vue&type=script&lang=js&"
export * from "./Dialog_DiscountType.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_DiscountType.vue?vue&type=style&index=0&id=708f6481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f6481",
  null
  
)

export default component.exports